import React from 'react';
import factory from 'components/Icons/factory';

export const Frame = factory(
  'Frame',
  <path d="M128 128H0V0h128v128zM111.9 16h-96v96h96V16z" />
);

export default Frame;
